import { rootApi } from "../../api/rootApi";


export const genuinemarkApi = rootApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchGenuinemark: builder.query({
            query: (token) => {
                return {
                method: 'GET',
                url: '/admin/genuinemark',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                  },
            }}
        }),
        addGenuinemark : builder.mutation({
            query: (params) => {
                return {
                method: 'POST',
                url: '/admin/genuinemark/add',
                headers: {
                    "Content-Type": "application/json",
                    authorization: "Bearer " + params.token,
                },
                body : JSON.stringify(params.body)
            }}
        }),
        
    })

});
export const { useFetchGenuinemarkQuery , useAddGenuinemarkMutation } = genuinemarkApi;